module.exports = __webpack_public_path__ + "static/soundcanvasreport-e69363afe2f08e8f7fea7bdeb89200e1.pdf";